import { useMemo, useCallback } from 'react';
import { FaCheckCircle } from 'react-icons/fa';

import { Button } from '@client/toolkit';

import { OnboardingBuilding } from '../onboarding.types';
import { PortfolioPaths } from '../../portfolio.router';

interface StepFerdigProps {
  buildings: OnboardingBuilding[];
  tenantId?: string;
  tenantName?: string;
}

export function StepFerdig({ buildings, tenantId, tenantName }: StepFerdigProps) {
  const selectedBuildings = useMemo(() => buildings.filter((b) => b.selected), [buildings]);
  const totalBra = useMemo(
    () => selectedBuildings.reduce((sum, b) => sum + b.bra, 0),
    [selectedBuildings],
  );

  const nextSteps = [
    'Rediger arealstruktur per bygg',
    'Legg til leietakere og kontrakter',
    'Legg til driftskostnader',
    'Sett markedsleie per bygg',
  ];

  return (
    <div className="flex flex-col items-center text-center">
      <FaCheckCircle className="text-brand-primary text-6xl mb-6" />

      <h2 className="text-3xl font-bold text-white mb-3">
        {tenantName ? `${tenantName} er klar!` : 'Porteføljen er klar!'}
      </h2>
      <p className="text-white/50 mb-10">
        {selectedBuildings.length} bygg registrert · {totalBra.toLocaleString('nb-NO')} m²
      </p>

      <div className="w-full max-w-md">
        <div className="text-xs font-semibold tracking-wider text-white/40 uppercase mb-4">
          Neste steg i appen:
        </div>

        <div className="space-y-3">
          {nextSteps.map((step, index) => (
            <div
              key={index}
              className="flex items-center gap-4 p-4 rounded-lg border border-border bg-surface-base text-left"
            >
              <div className="w-8 h-8 rounded-full border-2 border-brand-primary/40 flex items-center justify-center flex-shrink-0">
                <span className="text-brand-primary text-sm font-semibold">{index + 1}</span>
              </div>
              <span className="text-white text-sm">{step}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-10">
        <Button
          color="primary"
          size="lg"
          onClick={() => {
            // Set the newly created tenant as selected so the main App loads with it
            if (tenantId && tenantName) {
              window.localStorage.setItem(
                'exio.selectedTenant',
                JSON.stringify({ id: tenantId, name: tenantName }),
              );
            }
            // Full page reload to ensure App initializes fresh with the new tenant
            window.location.href = PortfolioPaths.BuildingList;
          }}
        >
          Gå til Dashboard →
        </Button>
      </div>
    </div>
  );
}
